// Angular
import { Injectable } from '@angular/core';

// Rxjs
import { Observable } from 'rxjs';

// Services
import { ApiService } from '../api/api.service';

// Models
import { Promo, PromoHelper } from '../../models/b2b/promo';
import { PromoType } from '../../models/b2b/promoType';
import { User, UserHelper } from '../../models/b2b/user';
import { ProductHelper, Product } from '../../models/b2b/product';
import { map } from 'rxjs/operators';
import { Subscriber } from 'app/shared/lib/helpers/subscriber';
import { Store } from '@ngrx/store';
import { AppState } from 'app/store';
import { validateApiResponse } from 'app/shared/lib/custom-rxjs-operators/api-response.operator';

@Injectable()
export class SoledadPromosService extends Subscriber {
    private addressCode: number = null;
    constructor(
        private api: ApiService,
        private store: Store<AppState>
    ) {
        super();

        this.addSubscription(
            this.store
                .select((state) => state.user.data.selectedAddressCode)
                .subscribe((selectedAddress) => {
                    if (selectedAddress !== undefined) {
                        this.addressCode = selectedAddress;
                    }
                })
        );
    }

    getPromoById(
        clienteCodigo: string,
        tipoPromo: PromoType,
        id: string,
        selectedAddress: number
    ): Observable<Promo[]> {
        tipoPromo = tipoPromo || PromoType.PROMO_TIPO_ACUMULADO;

        const params = [];
        params['CLIENTE'] = clienteCodigo;
        params['TIPOPROMO'] = tipoPromo;
        params['IDPROMO'] = id;
        params['DIRECCION'] = selectedAddress;

        //console.log("getPromoById", { ...params });

        return this.getPromosYAcumulativas(params);
    }

    getPromos(clienteCodigo: string, tipoPromo: PromoType, selectedAddress: number = null): Observable<Promo[]> {
        tipoPromo = tipoPromo || PromoType.PROMO_TIPO_ACUMULADO;

        const params = [];
        params['CLIENTE'] = clienteCodigo;
        params['TIPOPROMO'] = tipoPromo;
        if (selectedAddress !== null) {
            params['DIRECCION'] = selectedAddress;
        }

        // console.log('getPromos', { ...params });

        return this.getPromosYAcumulativas(params);
    }

    getPromosByAction(params): Observable<Promo[]> {
        // console.log('getPromosByAction', { ...params });

        return this.getPromosYAcumulativas(params);
    }

    getPromosYAcumulativas(params): Observable<Promo[]> {
        if (!!params['IDPROMO']) {
            params['AGRUPADAS'] = 1;
        }
        if (!params.hasOwnProperty('DIRECCION') && this.addressCode !== null) {
            params['DIRECCION'] = this.addressCode;
        }
        return this.api.callSoledad('b2bNew.dbo.HTML_PromosPedidoYAcumulativas', params).pipe(
            validateApiResponse('Error obteniendo promociones' + '. Params: ' + JSON.stringify(params)),
            map((data: any[]) => {
                let promos = data.map((promo: any) => PromoHelper.transformFromApi(promo));
                promos = promos.filter(
                    (promo, index, self) => index === self.findIndex((p) => p.idPromo === promo.idPromo)
                );

                return promos;
            })
        );
    }

    getPromosArticulos(user: User, idPromo: string | number): Observable<Product[]> {
        // console.log('getPromosArticulos', {idPromo}, {user});

        const params = [];
        params['CLIENTE'] = user.clienteCodigo;
        params['DIRECCIONENVIO'] = this.addressCode;
        params['ALMACEN'] = user.almacenCodigo;

        params['IDPROMO'] = idPromo;

        return this.api.callSoledad('b2bNew.dbo.HTML_PromosArticulos', params).pipe(
            validateApiResponse('Error obteniendo artículos de promoción' + '. Params: ' + JSON.stringify(params)),
            map((data: any[]) => {
                // console.log('HTML_PromosArticulos', {data});

                return data.map((item: any) => ProductHelper.transformFromApi(item, this.api.environment));
            })
        );
    }
}
